import React, { useState } from 'react';

const ClansAdd = ({ triggerToast, setCurrentPage, setSelectedClan, setUserClanID, setClan, setClanTag, fetchUserData, username }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [tag, setTag] = useState('');
  const [error, setError] = useState('');

  const validateInputs = () => {
    if (name.length > 10) {
      setError('Название должно быть не больше 10 символов.');
      return false;
    }
    if (description.length > 30) {
      setError('Описание должно быть не больше 30 символов.');
      return false;
    }
    if (tag.length > 5) {
      setError('Тэг должен быть не более 5 символов.');
      return false;
    }
    setError(''); // Сбрасываем ошибку, если всё в порядке
    return true;
  };

  // Обработчик отправки данных на сервер
  const handleCreateClan = async () => {
    if (!validateInputs()) return;

    const clanData = {
      name,
      description,
      tag,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/createClan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(clanData),
      });

      if (response.ok) {
        const result = await response.json();
        triggerToast('Клан создан успешно!');
        setSelectedClan(result.clan.id);
        setUserClanID(result.user.clan_id);
        setClan(result.clan);
        setClanTag(result.clan.tag);
        await fetchUserData(username);
        setCurrentPage('clans_info');
      } else {
        triggerToast('Ошибка создания клана!');
      }
    } catch (error) {
      console.error('Ошибка при создании клана:', error);
    }
  };

  return (
    <div className="container_">
      <h1>Создайте клан!</h1>
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
      <p>Название</p>
      <input
        className="add_pg"
        type="text"
        placeholder="Введите название"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <p>Описание</p>
      <input
        className="add_pg"
        type="text"
        placeholder="Введите описание"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <p>Тэг</p>
      <input
        className="add_pg"
        type="text"
        placeholder="Введите тэг"
        value={tag}
        onChange={(e) => setTag(e.target.value)}
      />
      <div className="clancreate_btn" onClick={handleCreateClan}>
        Создать!
      </div>
    </div>
  );
};

export default ClansAdd;
